import {graphql} from 'gatsby'
import React from 'react'

import {DatevBanner} from '@/components/banner-datev'
import type {
    BillsCalculatorFragment,
    CashbackCalculatorFragment,
    FeaturesComparisonTableFragment,
    ComponentPlaceholderSliceFragment,
    InvoiceGeneratorFragment,
    InvoiceTemplateFormFragment,
    VatCalculatorFragment,
} from '@/graphql-types'
import BillsCalculator from '@/sections/bills-calculator'
import {CashbackCalculator} from '@/sections/cashback-calculator'
import {FeaturesComparisonTable} from '@/sections/features-comparison-table'
import {InvoiceGenerator} from '@/sections/invoice-generator/invoice-generator'
import {InvoiceTemplateForm} from '@/sections/invoice-template-form'
import {VatCalculator} from '@/sections/vat-calculator/vat-calculator'

enum ComponentName {
    BillsCalculator = 'BillsCalculator',
    CashbackCalculator = 'CashbackCalculator',
    ComparisonTable = 'ComparisonTable',
    DatevBanner = 'DatevBanner',
    InvoiceGenerator = 'InvoiceGenerator',
    VatCalculator = 'VatCalculator',
    InvoiceTemplateForm = 'InvoiceTemplateForm',
}

export const ComponentPlaceholderSlice = ({slice}: {slice: ComponentPlaceholderSliceFragment}) => {
    const componentType = slice.primary.component
    const content = slice.primary.predefined_component

    switch (componentType) {
        case ComponentName.BillsCalculator: {
            return <BillsCalculator content={content.document as BillsCalculatorFragment} />
        }

        case ComponentName.CashbackCalculator: {
            return <CashbackCalculator content={content.document as CashbackCalculatorFragment} />
        }

        case ComponentName.DatevBanner: {
            return <DatevBanner />
        }

        case ComponentName.ComparisonTable: {
            return (
                <FeaturesComparisonTable
                    content={content.document as FeaturesComparisonTableFragment}
                />
            )
        }

        case ComponentName.VatCalculator: {
            return (
                <VatCalculator content={content.document.data as VatCalculatorFragment['data']} />
            )
        }

        case ComponentName.InvoiceGenerator: {
            return (
                <InvoiceGenerator
                    content={content.document.data as InvoiceGeneratorFragment['data']}
                />
            )
        }

        case ComponentName.InvoiceTemplateForm: {
            return <InvoiceTemplateForm content={content.document as InvoiceTemplateFormFragment} />
        }

        default: {
            throw new Error('Unrecognized component')
        }
    }
}

export const componentPlaceholderSliceFragment = graphql`
    fragment ComponentPlaceholderSlice on PrismicSlicePageDataBodyComponentPlaceholder {
        __typename
        primary {
            component
            predefined_component {
                type
                document {
                    ...BillsCalculator
                    ...CashbackCalculator
                    ...FeaturesComparisonTable
                    ...InvoiceGenerator
                    ...VatCalculator
                    ...InvoiceTemplateForm
                }
            }
        }
    }
`
